export const MAX_NUM_DEFAULT = 20;
export const LENGTH_DEFAULT = 9;
